import { useWorkingPlatform } from '@repo/platform';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import ErrorPageLayout from '@/components/error/ErrorPageLayout';
import { useExitService } from '@/lib/hooks/use-exit-service';

function BasicFallback() {
  const router = useRouter();
  const { workingPlatformType } = useWorkingPlatform();
  const { exitService } = useExitService();
  const [isRightButton, setIsRightButton] = useState(true);

  useEffect(() => {
    setIsRightButton(workingPlatformType === 'app');
  }, [workingPlatformType]);

  return (
    <>
      <Head>
        <title>비즈넵 | 알 수 없는 에러</title>
      </Head>
      <ErrorPageLayout
        title="일시적인 오류입니다"
        message="이용에 불편을 드려 죄송합니다."
        onClick={router.back}
        onClose={exitService}
        isRightButton={isRightButton}
      />
    </>
  );
}

export default BasicFallback;
